import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CompletedCampaignResult } from 'src/app/core-module/models/Campaigns/completed-campaign-result';

@Component({
    selector: 'app-campaign-question-detail',
    templateUrl: './campaign-question-detail.component.html',
    styleUrl: './campaign-question-detail.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CampaignQuestionDetailComponent {

  @Input() Campaign: CompletedCampaignResult;


  constructor(){
  }

}
